import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import type { BrandAnalysisResponse } from '@/context/brand-context'

export const useAnalyzeBrand = () => {
  const {
    mutate: analyzeBrand,
    mutateAsync: analyzeBrandAsync,
    error,
    isPending,
    data
  } = useMutation({
    mutationFn: (url: string) =>
      axios
        .post<BrandAnalysisResponse>('/brand-analysis/analyze', { url })
        .then(({ data }) => data)
  })

  return { analyzeBrand, analyzeBrandAsync, isPending, error, data }
}
